import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GradientConfig} from '../../../../app-config';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
})
export class NavigationComponent {
  public windowWidth: number;
  public gradientConfig: any;

  @Input() topPadding: number;

  @Output() onNavMobCollapse = new EventEmitter();

  constructor() {
    this.gradientConfig = GradientConfig.config;
    this.windowWidth = window.innerWidth;
  }

  navMobCollapse() {
    if (this.windowWidth < 992) {
      this.onNavMobCollapse.emit();
    }
  }
}
